/* eslint-disable */
import createIcon from '../createIcon';

const IconBranchDropdown = createIcon({
  name: 'icon-branch-dropdown',
  content: '<path d="M511.667 682.667c81.066 0 145.066-55.467 166.4-128H853c25.6 0 42.667-17.067 42.667-42.667S878.6 469.333 853 469.333H678.067c-17.067-72.533-85.334-128-166.4-128-81.067 0-145.067 55.467-166.4 128H170.333c-25.6 0-42.666 17.067-42.666 42.667s17.066 42.667 42.666 42.667h174.934c21.333 72.533 85.333 128 166.4 128zM426.333 512c0-46.933 38.4-85.333 85.334-85.333C558.6 426.667 597 465.067 597 512s-38.4 85.333-85.333 85.333c-46.934 0-85.334-38.4-85.334-85.333z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconBranchDropdown;
